import { useExperienceGainStore } from "stores/experienceGainStore";
import { ExperienceGainNotification } from "../ExperienceGainNotification";

export default function ExperienceGainOverlay() {
  const { activeGains, removeExperienceGain } = useExperienceGainStore();

  return (
    <>
      {activeGains.map((gain, index) => (
        <ExperienceGainNotification
          key={gain.id}
          expGained={gain.amount}
          show={true}
          onComplete={() => removeExperienceGain(gain.id)}
          className={`transform ${
            // Offset multiple notifications vertically
            index > 0 ? `translate-y-${index * 16}` : ""
          }`}
          position="fixed"
        />
      ))}
    </>
  );
}
